import { createAction } from 'redux-actions';
import { SET_SCOPE } from "../../constants.js";
export var setScope = createAction(SET_SCOPE);